// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3_8vS","modalFooterButton":"ModalNotes_modalFooterButton__2eKox"};